import { render } from "./PhoneProducts.vue?vue&type=template&id=15d6e423&scoped=true"
import script from "./PhoneProducts.vue?vue&type=script&lang=js"
export * from "./PhoneProducts.vue?vue&type=script&lang=js"

import "./PhoneProducts.vue?vue&type=style&index=0&id=15d6e423&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15d6e423"]])

export default __exports__